<template>
  <page-header-wrapper>
    <a-card :bordered='false'>
      <!-- 条件搜索 -->
      <div class='table-page-search-wrapper'>
        <a-form layout='inline'>
          <a-row :gutter='48'>

            <a-col :md='6' :sm='24'>

              <a-form-item label='优惠券序列号' prop='couponNum'>

                <a-input v-model='queryParam.couponNum' placeholder='请输入优惠券序列号'
                         allow-clear />
              </a-form-item>

            </a-col>
            <a-col :md='4' :sm='24'>
              <a-form-item label="核销状态" prop="useFlag">
                <a-select v-model="queryParam.useFlag" placeholder="请选择状态" style="width: 100%" allow-clear>
                  <a-select-option :value="0">未核销</a-select-option>
                  <a-select-option :value="1">已核销</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='4' :sm='24'>

              <a-form-item label='创建时间' prop='createTime'>
                <a-date-picker v-model="queryParam.createTime" @change='changeDate'/>
<!--                <a-input v-model='queryParam.createTime' placeholder='请输入优惠券序列号'-->
<!--                         allow-clear />-->
              </a-form-item>

            </a-col>
            <a-col :md='!advanced && 6 || 24' :sm='24'>
              <a-button type='primary' @click='handleQuery'><a-icon type='search' />查询</a-button>
              <a-button style='margin-left: 8px' @click='resetQuery'><a-icon type='redo' />重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class='table-operations'>
        <a-button type='primary' @click='$refs.createForm.handleAdd()'>
          <a-icon type='plus' />
          新增
        </a-button>
        <a-button type='primary' @click='$refs.bathModel.audit()'>
          <a-icon type='edit' />
          批量生成
        </a-button>
        <a-button type='danger' :disabled='multiple' @click='handleDelete'>
          <a-icon type='delete' />
          删除
        </a-button>
        <a-button type='primary' @click='handleExport' >
          <a-icon type='download' />
          导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync='tableSize'
          v-model='columns'
          :refresh-loading='loading'
          @refresh='getList' />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref='createForm'
        @ok='getList'
      />
      <bath-model ref="bathModel" @close="auditClose"></bath-model>
      <!-- 数据展示 -->
      <a-table
        :loading='loading'
        :size='tableSize'
        rowKey='id'
        :columns='columns'
        :data-source='list'
        :row-selection='{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }'
        :pagination='false'
        :bordered='tableBordered'
      >
                <span slot='createTime' slot-scope='text, record'>
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="img" slot-scope="text,record">
          <img :src="record.qrCode" style="width: 80px;height: 80px;"/>
        </span>
        <span slot='operation' slot-scope='text, record'>
          <a-divider type='vertical'  />
          <a @click='$refs.createForm.handleUpdate(record, undefined)'
             >
            <a-icon type='edit' />修改
          </a>
          <a-divider type='vertical'  />
          <a @click='handleDelete(record)' >
            <a-icon type='delete' />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class='ant-table-pagination'
        show-size-changer
        show-quick-jumper
        :current='queryParam.pageNum'
        :total='total'
        :page-size='queryParam.pageSize'
        :pageSizeOptions='pageOptions'
        :showTotal='total => `共 ${total} 条`'
        @showSizeChange='onShowSizeChange'
        @change='changeSize'
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCoupon, listCoupon, delCoupon } from '@/api/coupon/coupon'
import CreateForm from './modules/CreateForm'
import BathModel from '@/views/coupon/modules/BathModel.vue'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'Coupon',
  components: {
    BathModel,
    CreateForm
  },
  mixins: [tableMixin],

  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      pageOptions:[10,50,100,200],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        couponNum: null,
        useFlag: null,
        createTime:null,
        createBeginTime:null,
        createEndTime:null,
        pageNum: 1,
        pageSize: 100
      },
      columns: [
        {
          title: '主键id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券序列号',
          dataIndex: 'couponNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券二维码',
          dataIndex: 'qrCode',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'img' }
        },
        {
          title: '会员月份时长',
          dataIndex: 'month',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否核销使用',
          dataIndex: 'useFlag',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            return value == 1 ? '已核销' : '未核销';
          }
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询优惠券列表 */
    getList() {
      this.loading = true
      pageCoupon(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    changeDate(value,item){
      this.queryParam.createTime = item
      this.queryParam.createBeginTime = item +" 00:00:00";
      this.queryParam.createEndTime = item +" 23:59:59";
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        couponNum: undefined,
        pageNum: 1,
        pageSize: 100
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delCoupon(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('coupon/coupon/export', {
            ...that.queryParam
          }, `优惠券_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    auditClose() {
      this.getList();
    }
  }
}
</script>
